import { Routes } from '@angular/router';
export const financeRoutes: Routes = [
  {
    path: 'fin-account',
    loadComponent: () =>
      import('./fin-account/fin-account').then((x) => x.FinAccount),
    data: { privileges: ['fin_account_view'], moduleName: 'fin-account' },
  },
  {
    path: 'fin-category',
    loadComponent: () =>
      import('./fin-category/fin-category').then((x) => x.FinCategory),
    data: { privileges: ['fin_category_view'], moduleName: 'fin-category' },
  },
  {
    path: 'fin-transaction',
    loadComponent: () =>
      import('./fin-transaction/fin-transaction').then((x) => x.FinTransaction),
    data: { privileges: ['transaction_view'], moduleName: 'fin-transaction' },
  },
  {
    path: 'fin-openbank',
    loadComponent: () =>
      import('./fin-monitoring/fin-monitoring').then((x) => x.FinMonitoring),
    data: { privileges: ['fin_monitoring_view'], moduleName: 'fin-openbank' },
  },
  {
    path: 'profit',
    loadComponent: () =>
      import('./fin-profit/fin-profit').then((x) => x.FinProfit),
    data: { privileges: ['fin_profit_view'], moduleName: 'profit' },
  },
  {
    path: 'money',
    loadComponent: () =>
      import('./fin-money/fin-money').then((x) => x.FinMoney),
    data: { privileges: ['fin_money_view'], moduleName: 'money' },
  },
];
